import { useEditMode } from '../contexts/EditModeContext'
import {Pencil, X, Eye} from 'lucide-react'
import { motion, AnimatePresence } from 'framer-motion'

const EditModeFAB = () => {
  const { isEditMode, setIsEditMode, isAdmin } = useEditMode()

  if (!isAdmin) return null

  return (
    <>
      {/* Top banner when edit mode is active */}
      <AnimatePresence>
        {isEditMode && (
          <motion.div
            initial={{ y: -50, opacity: 0 }}
            animate={{ y: 0, opacity: 1 }}
            exit={{ y: -50, opacity: 0 }}
            transition={{ type: 'spring', stiffness: 300, damping: 30 }}
            className="fixed top-[73px] left-0 right-0 z-40 bg-[#7F1734] text-white py-2 px-4 flex items-center justify-center gap-3 shadow-lg"
          >
            <Pencil size={14} />
            <span className="text-sm font-medium tracking-wide">
              Edit Mode — Click on any text to edit it directly
            </span>
            <button
              onClick={() => setIsEditMode(false)}
              className="ml-4 flex items-center gap-1.5 px-3 py-1 bg-white/20 hover:bg-white/30 rounded text-xs font-medium transition-colors"
            >
              <Eye size={12} />
              Exit
            </button>
          </motion.div>
        )}
      </AnimatePresence>

      {/* Floating Action Button */}
      <motion.button
        onClick={() => setIsEditMode(!isEditMode)}
        className={`fixed bottom-6 right-6 z-50 w-14 h-14 rounded-full shadow-2xl flex items-center justify-center transition-colors ${
          isEditMode
            ? 'bg-[#2C2C2C] hover:bg-[#1a1a1a]'
            : 'bg-[#7F1734] hover:bg-[#6b1229]'
        }`}
        whileHover={{ scale: 1.1 }}
        whileTap={{ scale: 0.95 }}
        title={isEditMode ? 'Exit edit mode' : 'Enable edit mode'}
      >
        <AnimatePresence mode="wait">
          {isEditMode ? (
            <motion.div
              key="close"
              initial={{ rotate: -90, opacity: 0 }}
              animate={{ rotate: 0, opacity: 1 }}
              exit={{ rotate: 90, opacity: 0 }}
              transition={{ duration: 0.2 }}
            >
              <X size={22} className="text-white" />
            </motion.div>
          ) : (
            <motion.div
              key="edit"
              initial={{ rotate: 90, opacity: 0 }}
              animate={{ rotate: 0, opacity: 1 }}
              exit={{ rotate: -90, opacity: 0 }}
              transition={{ duration: 0.2 }}
            >
              <Pencil size={20} className="text-white" />
            </motion.div>
          )}
        </AnimatePresence>
      </motion.button>
    </>
  )
}

export default EditModeFAB
